cv.Router = Marionette.AppRouter.extend({
  routes: {
    '*any':                         "pay"
  },

  initialize: function(options){
  },

  before: function(route, params){
  },

  after: function(route, params){
  },

  pay: function(){
    cv.rootView.showChildView('app', new cv.PayView({
      model : cv.pay
    }));
  }
});